import { render, staticRenderFns } from "./ResumoCalculo.vue?vue&type=template&id=4ce2a2f5&scoped=true&"
import script from "./ResumoCalculo.vue?vue&type=script&lang=js&"
export * from "./ResumoCalculo.vue?vue&type=script&lang=js&"
import style0 from "./ResumoCalculo.vue?vue&type=style&index=0&id=4ce2a2f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce2a2f5",
  null
  
)

export default component.exports